import styles from './index.module.scss'
const Textarea = ({placeholder,name}) => {
   return (
      <textarea className={styles.textarea} name={name} id={name} placeholder={placeholder}/>
   )
}

export default Textarea;